module.exports = __webpack_public_path__ + "media/images/services/capacity-384b00bc7d47720e4a26fc03f19162bc.jpg";